module.exports = __webpack_public_path__ + "img/puerto-vallarta-marigalante.50525cd3.jpg";